define('gumbo-js-client-lib/forms/metaData/MetaDataForm',{
	dfeEvents: null,
	logicalEvents: null,
	timestamp: null,
	dispatchNumber: null,
	wait: null
});
